import { Box, Stack } from '@mui/material';

import { url } from '../../appRouter/url';
import { ContentLoading, EasyBreadcrumbs, type EasyBreadcrumbsItem, NoContentInfo } from '../../components/general';
import { useNormalizedParams } from '../../hooks/useNormalizedParams';
import { usePageTitle } from '../../hooks/usePageTitle';
import { trpc } from '../../trpc';
import { formatBuchungsnummern } from '../../utils/themaProdukte';
import { VeranstaltungPlanung } from './VeranstaltungPlanung';

export const ThemaVeranstaltungPlanungPage = () => {
  const { akaThemaId } = useNormalizedParams();

  if (akaThemaId === undefined) {
    throw new TypeError('Die Aka-Thema-Id fehlt in der URL.');
  }

  const themaQuery = trpc.thema.getThemaByAkaThemaId.useQuery(akaThemaId);

  usePageTitle(themaQuery.data && `${formatBuchungsnummern(themaQuery.data.thema)} | Veranstaltung anlegen`);

  if (themaQuery.error) {
    return <NoContentInfo content="Veranstaltung konnte nicht gefunden werden" />;
  }

  if (themaQuery.isLoading || !themaQuery.data) {
    return <ContentLoading />;
  }

  const breadcrumbs: EasyBreadcrumbsItem[] = [
    {
      href: url.root(),
      label: 'Dashboard',
    },
    {
      href: url.thema.details(themaQuery.data.thema.akaThemaId),
      label: 'Thema',
    },
    {
      href: '',
      label: 'Veranstaltung anlegen',
    },
  ];

  return (
    <Stack direction="column">
      <Box sx={{ my: 2 }}>
        <EasyBreadcrumbs items={breadcrumbs} />
      </Box>
      <VeranstaltungPlanung thema={themaQuery.data.thema} />
    </Stack>
  );
};
